import React from 'react';
interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  hoverable?: boolean;
}
export function Card({
  children,
  hoverable = false,
  className = '',
  ...props
}: CardProps) {
  return <div className={`
        bg-navy-light border border-navy-lighter rounded-lg overflow-hidden
        ${hoverable ? 'hover:bg-navy-hover hover:border-gray-600 transition-all cursor-pointer' : ''}
        ${className}
      `} {...props} data-id="element-11">
      {children}
    </div>;
}